import { Table } from 'antd';
import React from 'react';
import { roundAndFormat } from '../../../lib/utils';
import { OrderLine } from '../../../types/PurchaseOrder';

interface PurchaseOrderInfoTableProps {
  orderLines: OrderLine[];
}
const PurchaseOrderInfoTable: React.FC<PurchaseOrderInfoTableProps> = ({
  orderLines,
}) => {
  return (
    <>
      <Table
        rowKey={(record) => record.id}
        dataSource={orderLines}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      >
        <Table.Column
          title="Product"
          dataIndex="product"
          render={(product, record: OrderLine) => {
            return <span>{record.product?.description}</span>;
          }}
        />
        <Table.Column
          title="Code"
          dataIndex="productCode"
          render={(product, record: OrderLine) => {
            return <span>{record.product?.code}</span>;
          }}
        />
        <Table.Column
          title="Product UoM"
          dataIndex="productUoM"
          render={(product, record: OrderLine) => {
            return <span>{record.productUom?.description}</span>;
          }}
        />
        <Table.Column
          title="Quantity"
          dataIndex="quantity"
          render={(_text, record: OrderLine) => {
            return roundAndFormat(record.quantity);
          }}
        />
        <Table.Column title="Unit Price" dataIndex="unitPrice" />
        <Table.Column
          title="Total Amount"
          dataIndex="totalAmount"
          render={(totalAmount, record: OrderLine) => {
            return (
              <span>{roundAndFormat(record.quantity * record.unitPrice)}</span>
            );
          }}
        />
      </Table>
    </>
  );
};

export default PurchaseOrderInfoTable;
